<template>
    <div class="bg-gradient-to-br from-blue to-blue-dark text-white rounded-md px-2">
        <span class="text-xs">
            {{ $t('new_tag').toUpperCase() }}
        </span>
    </div>
</template>
